module.exports = __webpack_public_path__ + "img/a1.ab9af5cd.png";